import React from 'react';
import {Switch, Route} from 'react-router';
import List from './List';
import Form from './formId';

export default () => (
  <div className="p-8 bg-c-bg h-[calc(100vh-60px)] overflow-scroll">
    <Switch>
      <Route path="/form/forms/:formId" component={Form} />
      <Route component={List} />
    </Switch>
  </div>
);
